import { Legend } from "recharts";
import { Grid, Typography, Box } from "@material-ui/core";

import { COLORS } from "../../../../theme/colors";
import { getPowerAssetsGroupColor } from "./getPowerAssetsGroupColor";

const containerStyle = { width: "auto" };
const labelStyle = { color: COLORS.darks[0][100] };

function getPowerAssetsGroupName(powerAssetGroupType) {
  switch (powerAssetGroupType) {
    case "batteries":
      return "Batteries";
    case "solar":
      return "Solar";
    case "ev":
      return "EV Charger";
    default:
      return "";
  }
}

export function CustomLegend({ powerAssetsGroupTypesSet }) {
  return (
    <Grid container spacing={4} justifyContent="flex-end">
      {[...powerAssetsGroupTypesSet].map((powerAssetGroupType) => {
        return (
          <Grid
            key={powerAssetGroupType}
            container
            item
            spacing={1}
            alignItems="center"
            style={containerStyle}
          >
            <Grid item>
              <Box
                width={8}
                height={8}
                style={{ backgroundColor: getPowerAssetsGroupColor(powerAssetGroupType) }}
              ></Box>
            </Grid>
            <Grid item>
              <Typography variant="body2" style={labelStyle}>
                {getPowerAssetsGroupName(powerAssetGroupType)}
              </Typography>
            </Grid>
          </Grid>
        );
      })}
    </Grid>
  );
}

export function getNewPowerAssetsGanttChartLegend(recommendedPowerAssetsGroups) {
  const powerAssetsGroupTypesSet = new Set();

  recommendedPowerAssetsGroups.forEach((recommendedPowerAssetsGroup) =>
    powerAssetsGroupTypesSet.add(recommendedPowerAssetsGroup.type)
  );

  return (
    <Legend
      key="legend"
      verticalAlign="top"
      content={<CustomLegend powerAssetsGroupTypesSet={powerAssetsGroupTypesSet} />}
    />
  );
}
